module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAYAAABvCO8sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEKSURBVHgB7ZbtDYIwEIYP4391AzYQN+gIbmCcwDgB3cCV6gTqBLCBblDv5AgVYz+JJIYnuTThjntpe/QKYEFrXaDdtR8UJyEFTHDR4SxtOWcOzfblPHOAMTXHLlIEB+fnghmueY7jCbrlMxE8KnDjE3skwZKDbYFDIEiDBAtoZkjkbDV0RZAqQige929emi2XdgmJ0FZxrsp8/v9VGiWIy7Tlo2wHgcTOcA3Nb5RDINMevsC9EmY7wEeSXbLXKYQrV8gMH4l+f0HsPgptZbQiyS5pdCjyK1euqWi+cUa7ot0gkDlEwHu1gQhGX9K2tAWkI3o5P6Ernva/h/piP+B1c/mtdDr04QcYmyd4yWwCyjjgBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenzhenshi_bai.png
// module id = X1OR
// module chunks = 5